import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=340f9c86&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=340f9c86&lang=stylus&scoped=true&"
import style1 from "./Registration.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f9c86",
  null
  
)

export default component.exports